"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Image = Image;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("@heroui/react");
var react_2 = require("react");
var radiusClasses = {
    none: "rounded-none",
    sm: "rounded-sm",
    md: "rounded-md",
    lg: "rounded-lg",
    full: "rounded-full",
};
var shadowClasses = {
    none: "shadow-none",
    sm: "shadow-sm",
    md: "shadow-md",
    lg: "shadow-lg",
};
function Image(props) {
    var src = props.src, alt = props.alt, className = props.className, _a = props.radius, radius = _a === void 0 ? "none" : _a, _b = props.shadow, shadow = _b === void 0 ? "none" : _b, _c = props.isZoomed, isZoomed = _c === void 0 ? false : _c, _d = props.isBlurred, isBlurred = _d === void 0 ? false : _d, fallbackSrc = props.fallbackSrc, onError = props.onError, rest = __rest(props, ["src", "alt", "className", "radius", "shadow", "isZoomed", "isBlurred", "fallbackSrc", "onError"]);
    var _e = (0, react_2.useState)(src), imgSrc = _e[0], setImgSrc = _e[1];
    var handleError = function (event) {
        if (fallbackSrc && imgSrc !== fallbackSrc) {
            setImgSrc(fallbackSrc);
        }
        onError === null || onError === void 0 ? void 0 : onError(event);
    };
    var image = ((0, jsx_runtime_1.jsx)("img", __assign({ src: imgSrc, alt: alt, onError: handleError, className: (0, react_1.cn)(radiusClasses[radius], shadowClasses[shadow], isZoomed && "object-cover transition-transform duration-300 hover:scale-125", className) }, rest)));
    if (isBlurred) {
        return ((0, jsx_runtime_1.jsxs)("div", { className: (0, react_1.cn)("relative", radiusClasses[radius], shadowClasses[shadow]), children: [image, (0, jsx_runtime_1.jsx)("img", { src: imgSrc, alt: "", "aria-hidden": "true", className: (0, react_1.cn)("absolute inset-0 z-0 h-full w-full scale-105 object-cover blur-lg opacity-30 saturate-150", radiusClasses[radius]) })] }));
    }
    if (isZoomed) {
        return (0, jsx_runtime_1.jsx)("div", { className: (0, react_1.cn)("relative overflow-hidden", radiusClasses[radius], shadowClasses[shadow]), children: image });
    }
    return image;
}
